<div class="container">
    <div class="row">
        <div class="col-md-12">
            <h3>
            Please wait ! Redirecting you to main site !
            </h3>
        </div>
    </div>
</div>
